<template>
  <div class="CourseManagement">
    <AppHeader>课程管理</AppHeader>
    <AppBox class="appBox">
      <course-table></course-table>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import CourseTable from "@/pages/CourseManagement/CourseTable.vue";
import AppTable from "@/components/ui/AppTable/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";

export default {
  name: "CourseManagement",
  components: {AppBox, AppTable, CourseTable, AppHeader},
  data() {
    return {};
  },
  computed: {},
  async mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.CourseManagement {
  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>
